var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SideWidget',{staticClass:"box-shadow-white p-2",class:( _obj = {
    'item-locked': _vm.locked
  }, _obj[_vm.$style.wrapper] = true, _obj[_vm.$style.locked] = _vm.locked, _obj ),attrs:{"title":false},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{class:_vm.$style.content},[(_vm.locked)?_c('i',{staticClass:"icon"}):_vm._e(),_c('div',{class:_vm.$style.mobile},[_c('h3',[_vm._v("My Schedule")]),_c('CalendarLink')],1)])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }